module.exports = BMAP_ANCHOR_BOTTOM_RIGHT;